import styled, { createGlobalStyle } from 'styled-components'
import colors from 'globals/colors'
import measures from 'globals/measures'

export const DialogContent = styled.div`
  padding-top: 35px;
  
  @media (max-width: ${measures.mobileThreshold}px) {
    height: 100%;
  }
`

export const DialogStyle = createGlobalStyle`
  .dialog {
    width: 100% !important;
    max-width: 751px !important;
    
    & .ant-modal-close svg .color-stroke {
      stroke: ${colors.darkGrey};
    }
    
    & .ant-modal-content {
      border-radius: 4px;
    }
    
    @media (max-width: ${measures.mobileThreshold}px) {
      height: 100%;
      margin: 0;
      padding: 0;
      
      & .ant-modal-content {
        height: 100%;
        border-radius: 0;
        
        & .ant-modal-body {
          height: 100%;
        }
      }
    }
  }
`
